module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/OperationTypeIcon.d9729fb1.svg";